import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/src/lib/shadcn/cn"

const badgeVariants = cva(
  "inline-flex items-center rounded-full px-2 py-0.5 text-xs transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 whitespace-nowrap",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
        success: 
          "border-transparent bg-green-500/20 text-green-700 hover:bg-green-500/30",
        "roi-positive":
          "border-transparent bg-green-100 text-green-700 dark:bg-green-500/20 dark:text-green-400",
        "roi-negative":
          "border-transparent bg-red-100 text-red-700 dark:bg-red-500/20 dark:text-red-400",
        "roi-neutral":
          "bg-transparent border border-gray-300 text-gray-600 dark:border-gray-600 dark:text-gray-400",
        // Theme-based color variants
        blue:
          "bg-badge-blue text-badge-blue-foreground dark:border dark:border-badge-blue-border",
        indigo:
          "bg-badge-indigo text-badge-indigo-foreground dark:border dark:border-badge-indigo-border",
        yellow:
          "bg-badge-yellow text-badge-yellow-foreground dark:border dark:border-badge-yellow-border",
        orange:
          "bg-badge-orange text-badge-orange-foreground dark:border dark:border-badge-orange-border",
        purple:
          "bg-badge-purple text-badge-purple-foreground dark:border dark:border-badge-purple-border",
        green:
          "bg-badge-green text-badge-green-foreground dark:border dark:border-badge-green-border",
        red:
          "bg-badge-red text-badge-red-foreground dark:border dark:border-badge-red-border",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
